import { createStore } from 'vuex'

const store = createStore({
    state() {
        return {
        }
    },
    mutations: {
    },
    actions: {
    }
})

export default store